import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { COLLECTION_NOTICE_CONCEPTS_IDS } from '@core/constants';
import { CollectionNoticeModel } from '@core/models';
import {
  MigratedBalancesData,
  MigratedBalancesResponse,
} from '@core/models/payments/migrated-balances.model';
import { environment } from '@rcsa-frontend/environments/environment';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MigratedBalancesService {
  constructor(private http: HttpClient) {}

  public verifyMigratedBalances(
    collectionNotices: CollectionNoticeModel[],
    isAdmin = false
  ): Observable<MigratedBalancesData> {
    const url = `${environment.apiUrl}/v1${
      isAdmin ? '/admin' : ''
    }/payments/validate-pending-collection-notices-by-curp`;
    if (
      collectionNotices.some((collectionNotice) =>
        [
          COLLECTION_NOTICE_CONCEPTS_IDS.IN,
          COLLECTION_NOTICE_CONCEPTS_IDS.RI,
        ].includes(collectionNotice.concept.conceptCategory.id)
      )
    ) {
      return this.http
        .post<MigratedBalancesResponse>(url, {
          collection_notice_ids: collectionNotices.map(
            (collectionNotice) => collectionNotice.id
          ),
        })
        .pipe(
          map((response) =>
            response.data.hasAnyPendingCollectionNoticesByCurp ? response : null
          ),
          catchError(() => {
            return of('error' as const);
          })
        );
    }
    return of(null);
  }
}
